<template>
  <v-dialog v-model="showTagDialog" width="500px" persistent>
    <v-card>
      <v-card-title>
        {{ $t("management.healthHazards.tags") }}
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          class="mt-0 pt-0"
          v-model="newTags"
          :items="tagsAll"
          required
          chips
          deletable-chips
          return-object
          multiple
          :item-text="getTagTextWithActiveStatus"
          @change="unsavedTagChanges = true"
        >
          <template v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              @click="data.select"
              @click:close="removeTag(data.item)"
              :style="
                data.item.isActive ? '' : 'text-decoration: line-through;'
              "
            >
              {{ data.item.name }}
            </v-chip>
          </template>
        </v-autocomplete>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog">
          {{ $t("dialog.cancel") }}
        </v-btn>
        <v-btn
          color="primary"
          text
          :disabled="!unsavedTagChanges"
          @click="save"
        >
          {{ $t("dialog.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getDetailedTagText } from "@/utils/tag";

import TagsAllQuery from "@/graphql/queries/TagsAll.gql";

export default {
  props: ["selectedHealthHazard", "showTagDialog"],
  data() {
    return {
      unsavedTagChanges: false,
      newTags: [...this.selectedHealthHazard.tags],
    };
  },
  methods: {
    closeDialog() {
      this.$emit("update:showTagDialog", false);
    },
    save() {
      this.$emit(
        "save",
        this.selectedHealthHazard.id,
        this.newTags.map((tag) => tag.id)
      );
    },
    removeTag(tag) {
      const index = this.newTags.findIndex((t) => t.id === tag.id);
      if (index >= 0) {
        this.newTags.splice(index, 1);
      }
      this.unsavedTagChanges = true;
    },
    getTagTextWithActiveStatus(item) {
      return item.isActive
        ? getDetailedTagText(item)
        : `${this.$t("instructions.inactive")} ${getDetailedTagText(item)}`;
    },
    getDetailedTagText: getDetailedTagText,
  },
  apollo: {
    tagsAll: {
      query: TagsAllQuery,
      update: (data) => {
        return data.tagsAll;
      },
      skip() {
        return !this.showTagDialog;
      },
    },
  },
};
</script>
